import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { useNavigate, useLocation } from 'react-router-dom';
import PdfPreview from '../../../../Common/PDFPreview';
import { RingLoader } from 'react-spinners';
import { Typography } from '@mui/material';
import { FormaDateBalanceSheet } from "../../../../Common/FormatFunctions/FormatDate"
import { formatReadableAmount } from "../../../../Common/FormatFunctions/FormatAmount";

const apikey = process.env.REACT_APP_API;

const MillWiseDispatch = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const fromDate = searchParams.get('fromDate');
    const toDate = searchParams.get('toDate');

    const companyCode = sessionStorage.getItem('Company_Code');
    const Year_Code = sessionStorage.getItem('Year_Code');
    const Company_Name = sessionStorage.getItem('Company_Name');
    const Company_GSTNO = sessionStorage.getItem('Company_GSTNO');

    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [pdfPreview, setPdfPreview] = useState(null);

    const API_URL = `${apikey}/CategoryWiseDispatch-Register`;

    useEffect(() => {
        const fetchReportData = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await axios.get(API_URL, {
                    params: {
                        fromDT: fromDate,
                        toDT: toDate,
                        Company_Code: companyCode,
                        Year_Code: Year_Code,
                    },
                });
                setReportData(response.data);
            } catch (error) {
                console.error('Error fetching report:', error);
                setError('Error fetching report');
            } finally {
                setLoading(false);
            }
        };

        if (fromDate && toDate) {
            fetchReportData();
        }
    }, [fromDate, toDate, companyCode, Year_Code]);

    const handlePrint = () => {
        const printContent = document.getElementById('reportTable').outerHTML;
        const win = window.open('', '', 'height=700,width=900');
        win.document.write(`
            <html>
                <head>
                    <title>Print Report</title>
                    <style>
                        body {
                            font-family: Arial, sans-serif;
                            margin: 20px;
                        }
                        .company-name {
                            text-align: center;
                            font-size: 24px;
                            font-weight: bold;
                            margin-bottom: 20px;
                            color: #333;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin-bottom: 20px;
                        }
                        th, td {
                            border: 1px solid #ddd;
                            padding: 8px;
                            text-align: left;
                        }
                        th {
                            background-color: #f2f2f2;
                            font-weight: bold;
                        }
                        tr:nth-child(even) {
                            background-color: #f9f9f9;
                        }
                        .total-row {
                            background-color: #e0f7fa;
                            font-weight: bold;
                        }
                    </style>
                </head>
                <body>
                    <div class="company-name">${Company_Name}</div>
                    ${printContent}
                </body>
            </html>
        `);
        win.document.close();
        win.print();
    };

    const generatePdf = () => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const textWidth = doc.getTextWidth(Company_Name);
        const xPosition = (pageWidth - textWidth) / 2;

        doc.text(Company_Name, xPosition, 10);
        doc.autoTable({ html: '#reportTable' });

        const pdfBlob = doc.output('blob');
        const url = URL.createObjectURL(pdfBlob);
        setPdfPreview(url);
    };

    const handleExportToExcel = () => {
        const wb = XLSX.utils.book_new();
        const wsData = [];

        // Company name and spacing
        wsData.push([Company_Name]);
        wsData.push([]);

        // Table headers (match HTML)
        wsData.push([
            '#', 'Date', 'Mill', 'Voucher By', 'Getpass', 'Mill Rate', 'Quantal',
            'Sale Rate', 'Lorry No', 'Freight', 'Vasuli Amt', 'Transport', 'DO', 'Tender'
        ]);

        Object.entries(groupedReportData).forEach(([groupKey, { items }]) => {
            // Group header
            wsData.push([groupKey]);
            let totalQty = 0;

            items.forEach((item, index) => {
                const quantal = parseFloat(item.quantal || 0);
                totalQty += quantal;

                wsData.push([
                    item.doc_no,
                    item.doc_dateConverted,
                    item.millshortname,
                    item.voucherbyshortname,
                    item.getpassshortname,
                    item.mill_rate,
                    quantal,
                    item.sale_rate,
                    item.truck_no,
                    item.Freight_Amount,
                    item.vasuli_amount1,
                    item.transportshortname,
                    item.doshortname,
                    item.purc_no
                ]);
            });

            // Total row
            wsData.push([
                '', '', '', '', 'Total Qty:', '', totalQty.toFixed(2),
                '', '', '', '', '', '', ''
            ]);

            // Spacer row
            wsData.push([]);
        });

        const ws = XLSX.utils.aoa_to_sheet(wsData);
        XLSX.utils.book_append_sheet(wb, ws, 'MillWiseDispatch');
        XLSX.writeFile(wb, 'MillWiseDispatch.xlsx');
    };

    const groupReportData = (data) => {
        if (!Array.isArray(data)) return {};
        const grouped = {};
        data.forEach(item => {
            const key = `${item.mill_code}-${item.millname}`;
            if (!grouped[key]) {
                grouped[key] = { items: [] };
            }
            grouped[key].items.push(item);
        });
        return grouped;
    };

    const groupedReportData = groupReportData(reportData);

    return (
        <div style={{ marginTop: '-80px' }}>
            {/* <Typography variant="h6" style={{ textAlign: 'center', fontSize: "24px", fontWeight: "bold" }}>{Company_Name}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", textDecoration: 'underline', fontWeight: "550" }}>GSTN : {Company_GSTNO}</Typography> */}

            <div className="d-flex justify-content-between align-items-center">
                <div style={{ flex: 1, textAlign: 'center',marginLeft: "280px"  }}>
                    <Typography variant="h6" style={{ textAlign: 'center', fontSize: "20px", fontWeight: "bold" }}>Mill Wise Dispatch</Typography>
                    <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px" }}>{FormaDateBalanceSheet(fromDate)} to {FormaDateBalanceSheet(toDate)}</Typography>
                </div>

                <div className="d-flex justify-content-end">
                    <button className="btn btn-secondary me-2" onClick={handlePrint}>Print Report</button>
                    <button className="btn btn-success me-2" onClick={handleExportToExcel}>Export to Excel</button>
                </div>
            </div>

            {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                    <RingLoader />
                </div>
            ) : error ? (
                <div className="alert alert-danger">{error}</div>
            ) : (
                <div style={{ maxHeight: "800px", overflowY: "auto" }}>
                    <table className="table table-striped table-bordered mt-4" id="reportTable" style={{ marginBottom: "60px", width: "100%" }}>
                        <thead className="table-light" style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1, whiteSpace: "nowrap" }}>
                            <tr>
                                <th>#</th>
                                <th>Date</th>
                                <th>Mill Name</th>
                                <th>Voucher By</th>
                                <th>Get Pass</th>
                                <th>Mill Rate</th>
                                <th>Quintal</th>
                                <th>Sale Rate</th>
                                <th>Lorry No</th>
                                <th>Frieght</th>
                                <th>Vasuli Amount</th>
                                <th>Transport</th>
                                <th>DO</th>
                                <th>Tender No.</th>

                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(groupedReportData).map(([key, { items }]) => {
                                const totalQty = items.reduce((sum, item) => sum + parseFloat(item.quantal || 0), 0);
                                return (
                                    <React.Fragment key={key}>
                                        <tr>
                                            <td colSpan={15} align="left" className="table-primary" style={{ color: 'blue', fontWeight: 'bold' }}>{key}</td>
                                        </tr>
                                        {items.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ fontWeight: 'bold' }}>{item.doc_no}</td>
                                                <td style={{ fontWeight: 'bold' }}>{item.doc_dateConverted}</td>
                                                <td align="left">{item.millshortname}</td>
                                                <td align="left">{item.voucherbyshortname}</td>
                                                <td align="left">{item.getpassshortname}</td>
                                                <td align="right">{formatReadableAmount(item.mill_rate)}</td>
                                                <td align="right" style={{ fontWeight: 'bold' }}>{formatReadableAmount(item.quantal)}</td>
                                                <td align="right">{formatReadableAmount(item.sale_rate)}</td>
                                                <td align="left">{item.truck_no}</td>
                                                <td align="right">{item.Freight_Amount}</td>
                                                <td align="right">{item.vasuli_amount1}</td>
                                                <td align="left">{item.transportshortname}</td>
                                                <td align="left">{item.doshortname}</td>
                                                <td align="right">{item.purc_no}</td>
                                            </tr>
                                        ))}
                                        <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f8ff' }}>
                                            <td colSpan={6} align="right">Total Qty:</td>
                                            <td>{totalQty.toFixed(2)}</td>
                                            <td colSpan={7}></td>
                                        </tr>
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            {pdfPreview && (
                <div className="centered-container">
                    <PdfPreview pdfData={pdfPreview} apiData={reportData} label={'NewDispatchRegister'} />
                </div>
            )}
        </div>
    );
};

export default MillWiseDispatch;